module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.2ffc058d.ttf";